module.exports = __webpack_public_path__ + "img/Image_03.9795f5fe.jpg";